import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseViewStore from 'base-viewstore';
import BaseComponent from 'base-component';
import numeral from 'numeral';

import ResourcesViewStore from './viewstore';

@editable @observer
export class ResourcesComponent extends BaseComponent {

    static ViewStore = ResourcesViewStore;

    constructor(props) {
        super(props);

    }

    render() {
        const {
            currentView,
            contentModel,
            inputStore
        } = this.props;

        const {
            title,
            resources,
        } = contentModel;

        const {
          showDebrief,
          hideDebrief,
          debriefRound,
          debriefVisible,
          slide,
          totalSlides,
          prevSlide,
          nextSlide,
          debriefLoading
        } = this.viewStore

        return (
            <div className="resources-activity">
                <div className="title">{title}</div>
                <div className="resources">
                    {
                        resources.map( (resource) => {
                            if(resource.link == "debrief-1") {
                                return (
                                  <a className="resource" onClick={() => {showDebrief(1)}}>
                                      <i className={"fa fa-fw " + resource.icon}></i>
                                      <span className="resource-name" dangerouslySetInnerHTML={{__html: resource.name}}></span>
                                  </a>)
                            }
                            if(resource.link == "debrief-2") {
                                return (
                                  <a className="resource" onClick={() => {showDebrief(2)}}>
                                      <i className={"fa fa-fw " + resource.icon}></i>
                                      <span className="resource-name" dangerouslySetInnerHTML={{__html: resource.name}}></span>
                                  </a>)
                            }
                            return (
                            <a className="resource" href={resource.link} target="_blank">
                                <i className={"fa fa-fw " + resource.icon}></i>
                                <span className="resource-name" dangerouslySetInnerHTML={{__html: resource.name}}></span>
                            </a>)
                        })
                    }
                </div>
                <div className={"debrief" + (debriefVisible ? " show" : "") + (debriefLoading ? " loading" : "")}>
                  <div className="back-button" onClick={hideDebrief}></div>
                  <div className="title">Round {debriefRound} Debrief</div>
                  <div className="loading"><i className="fa fa-spin fa-spinner"></i></div>
                  <div id="slideshow" className={"slideshow slide-" + slide + " round" + debriefRound}>
                  <div className="slide round1" style={{textAlign:"center",background:"rgb(4,106,56)",color:"white"}}>
                      <h1 style={{marginTop:"20%"}}>Deloitte Industries Oil & Gas</h1>
                      <div style={{textAlign:"left"}}>
                        <h3>Debrief Round 1</h3>
                        <ul>
                          <li>Reserve Replacement Ratio</li>
                          <li>Events</li>
                          <li>Simulation Results</li>
                        </ul>
                      </div>
                  </div>
                  <div className="slide round1">
                      <h2>Winning Metrics</h2>
                      <span>Balanced Scorecard</span>
                      <ul>
                          <li>Reserve Replacement Ratio (RRR) – 30%</li>
                          <li>Market Share – 30%</li>
                          <li>Return on Capital Employed (ROCE) – 40%</li>
                      </ul>
                  </div>
                  <div className="slide round1">
                      <h2>Reserve Replacement Ratio (RRR)</h2>
                      <div style={{display:"flex"}}>
                          <div style={{marginTop:"60px"}}>RRR = </div>
                          <div style={{marginLeft:"20px"}}>
                              <p style={{borderBottom:"2px solid"}}>New Reserves Added</p>
                              <p style={{marginTop:"-15px"}}>Reserves Depleted<br/>(production)</p>
                          </div>
                      </div>
                  </div>
                  <div className="slide round1">
                      <h2>New Reserves Added</h2>
                      <ul>
                          <li>Lease Management</li>
                          <li>Exploration</li>
                          <li>Development</li>
                      </ul>
                  </div>
                  <div className="slide round1">
                      <h3>Leases - Global North - Conventional Gas - Drivers</h3>
                      <div id="graph-1-2"></div>
                  </div>
                  <div className="slide round1">
                      <h3>Leases - Global North - Conventional Gas</h3>
                      <div id="graph-1"></div>
                  </div>
                  <div className="slide round1">
                      <h3>Global North - Conventional Gas Exploration</h3>
                      <div id="graph-5"></div>
                  </div>
                  <div className="slide round1">
                      <h3>Total Developed Reserves - Gas</h3>
                      <div id="graph-9"></div>
                  </div>
                  <div className="slide round1">
                      <h3>Production - Conventional and Unconventional Gas</h3>
                      <div id="graph-11"></div>
                  </div>
                  <div className="slide round1">
                      <table style={{tableLayout: 'fixed', width: '90%', textAlign: 'center'}}>
                          <thead>
                              <tr id="rrr-header" style={{background: 'rgb(134,188,37)', color: "white"}}></tr>
                          </thead>
                          <tbody>
                              <tr id="rrr-north-oil" style={{background: "rgb(217,231,205)"}}></tr>
                              <tr id="rrr-north-gas" style={{background: "rgb(237,244,232)"}}></tr>
                              <tr id="rrr-south-oil" style={{background: "rgb(217,231,205)"}}></tr>
                              <tr id="rrr-south-gas" style={{background: "rgb(237,244,232)"}}></tr>
                          </tbody>
                      </table>
                  </div>
          
                  <div className="slide round2" style={{textAlign:"center",background:"rgb(4,106,56)",color:"white"}}>
                      <h1 style={{marginTop:"20%"}}>Deloitte Industries Oil & Gas</h1>
                      <div style={{textAlign:"left"}}>
                        <h3>Debrief Round 2</h3>
                        <ul>
                          <li>Market Share</li>
                          <li>Events</li>
                          <li>Simulation Results</li>
                        </ul>
                      </div>
                  </div>
                  <div className="slide round2">
                      <h3>Retail Market Share - Global North</h3>
                      <div id="graph-12"></div>
                  </div>
                  <div className="slide round2">
                      <h3>Retail Market Share - Global North - Drivers</h3>
                      <div id="graph-12-2"></div>
                  </div>
                  <div className="slide round2">
                      <h3>Retail Market Share - Global South</h3>
                      <div id="graph-13"></div>
                  </div>
                  <div className="slide round2">
                      <h3>Retail Market Share - Global South - Drivers</h3>
                      <div id="graph-13-2"></div>
                  </div>
          
                  <div className="slide round3" style={{textAlign:"center",background:"rgb(4,106,56)",color:"white"}}>
                      <h1 style={{marginTop:"20%"}}>Deloitte Industries Oil & Gas</h1>
                      <div style={{textAlign:"left"}}>
                        <h3>Debrief Round 3</h3>
                        <ul>
                          <li>ROCE</li>
                          <li>Events</li>
                          <li>Simulation Results</li>
                        </ul>
                      </div>
                  </div>
                  <div className="slide round3">
                      <h3>ROCE Tree</h3>
                      <img src="/assets/images/ROCE-Tree.png" style={{maxWidth:"100%"}}/>
                  </div>
                  <div className="slide round3">
                      <table style={{tableLayout: 'fixed', width: '90%', textAlign: 'center'}}>
                          <thead>
                              <tr id="roce-header" style={{background: 'rgb(134,188,37)', color: "white"}}></tr>
                          </thead>
                          <tbody>
                              <tr id="roce-earnings" style={{background: "rgb(217,231,205)"}}></tr>
                              <tr id="roce-capital" style={{background: "rgb(237,244,232)"}}></tr>
                              <tr id="roce-roce" style={{background: "rgb(217,231,205)"}}></tr>
                          </tbody>
                      </table>
                  </div>
                  <div className="slide round3">
                      <h3>ROCE</h3>
                      <div id="graph-30"></div>
                  </div>
          
                  <div className="slide round1 round2 round3">
                      <h3>Round Scores</h3>
                      <table style={{tableLayout: 'fixed', width: '90%', textAlign: 'center'}}>
                          <thead>
                              <tr id="scores-header"></tr>
                          </thead>
                          <tbody>
                              <tr id="scores-rrr"></tr>
                              <tr id="scores-rrr-points"></tr>
                              <tr className="scores-spacer" style={{height:"30px"}}></tr>
                              <tr id="scores-market"></tr>
                              <tr id="scores-market-points"></tr>
                              <tr className="scores-spacer" style={{height:"30px"}}></tr>
                              <tr id="scores-roce"></tr>
                              <tr id="scores-roce-points"></tr>
                              <tr className="scores-spacer" style={{height:"30px"}}></tr>
                              <tr id="scores-totals"></tr>
                              <tr className="scores-spacer" style={{height:"30px"}}></tr>
                              <tr className="scores-spacer" style={{height:"30px"}}></tr>
                              <tr id="scores-combined"></tr>
                          </tbody>
                      </table>
                  </div>
                  </div>
                  <div id="slide-control-left" className={"slide-control left" + (slide <= 0 ? " disabled" : "")} onClick={prevSlide}><i className="fa fa-chevron-left"></i></div>
                  <div id="slide-control-right" className={"slide-control right" + (slide >= totalSlides ? " disabled" : "")} onClick={nextSlide}><i className="fa fa-chevron-right"></i></div>
                  <div id="slide-show-count" className="slide-show-count">Slide {slide + 1} of {totalSlides + 1}</div>
                </div>
            </div>
        );
    }
}

export default ResourcesComponent; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/resources-activity/src/component.js